import { observable, action, computed, makeAutoObservable } from 'mobx';
import { MarketType } from 'src/api/config/marketFilters/getMarketsForSport';
import { MarketFromEvents, MarketFiltersState } from 'src/AppState/MarketFiltersState/MarketFiltersState';

export class BasicMarketItemState {
    @observable public isOpenFiltersSelect: boolean = false;
    @observable public isLoading: boolean = false;

    public constructor(
        readonly market: MarketFromEvents,
        readonly marketFiltersState: MarketFiltersState
    ) {
        makeAutoObservable(this);
    }

    @action toggleSelect = (): void => {
        this.isOpenFiltersSelect = !this.isOpenFiltersSelect;
    };

    @action addMarketHandler = async (): Promise<void> => {
        this.isLoading = true;
        await this.marketFiltersState.addMarketToCurrentFilter(this.market.market_name);
        this.isLoading = false;
    };

    @computed get isSelectedInCurrentFilter(): boolean {
        let isSelected = false;

        for (const market of this.marketFiltersState.marketsBySelectedFilter) {
            if (this.market.market_name === market.market_name) {
                isSelected = true;
            }
        }

        return isSelected;
    }

    isSelectedInCustomFilter = (filterId: number): MarketType | null => {
        for (const market of this.marketFiltersState.marketByCustomFilter(filterId)) {
            if (this.market.market_name === market.market_name) {
                return market;
            }
        }

        return null;
    };
}

export class BasicFilterItemState {
    @observable isChecked: boolean = false;

    public constructor(
        readonly filterId: number,
        readonly isSelectedInCustomFilter: (filterId: number) => MarketType | null,
        readonly marketFiltersState: MarketFiltersState,
        readonly marketFromEvent: MarketFromEvents
    ) {
        this.isChecked = Boolean(isSelectedInCustomFilter(filterId));
        makeAutoObservable(this);
    }

    @action toggleMarketHandler = (): void => {
        const market = this.isSelectedInCustomFilter(this.filterId);
        if (market !== null) {
            this.marketFiltersState.removeMarketFromFilter(market.market_id, this.marketFiltersState.currentSport);
            this.isChecked = false;
        } else {
            this.marketFiltersState.addMarketToAnyFilter(this.marketFromEvent.market_name, this.filterId);
            this.isChecked = true;
        }
    };
}
